module.exports = __webpack_public_path__ + "img/head.d1fecee4.png";